module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "auth-area"
  }, [_c('div', {
    staticClass: "auth-window"
  }, [_c('div', {
    staticClass: "auth-logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.logoUrl,
      "alt": "Widget Brain logo"
    }
  })]), _vm._v(" "), _c('form', {
    staticClass: "auth-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.resetPassword.apply(null, arguments)
      }
    }
  }, [_c('md-input-container', {
    attrs: {
      "md-has-password": ""
    }
  }, [_c('label', [_vm._v("Password")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1), _vm._v(" "), _c('md-input-container', {
    attrs: {
      "md-has-password": ""
    }
  }, [_c('label', [_vm._v("Repeat password")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.passwordRepeat),
      callback: function($$v) {
        _vm.passwordRepeat = $$v
      },
      expression: "passwordRepeat"
    }
  })], 1), _vm._v(" "), (_vm.requirements && _vm.requirements.length > 0) ? _c('div', [_c('ul', {
    staticClass: "errors-list"
  }, _vm._l((_vm.requirements), function(requirement) {
    return _c('li', [_vm._v("\n              " + _vm._s(requirement) + "\n            ")])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "auth-actions"
  }, [_c('md-button', {
    staticClass: "md-raised md-primary",
    attrs: {
      "type": "submit",
      "disabled": !_vm.password || !!_vm.requirements.length
    },
    on: {
      "submit": _vm.resetPassword
    }
  }, [_vm._v("Reset pw")])], 1)], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-39e4cd1c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PasswordChange.vue
// module id = 307
// module chunks = 2